var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueBadgeHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.6,
    viewBox: "0 0 14 15.6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L14 4V11.6L7 15.6L0 11.6V4L7 0Z",
    fill: "#CA4CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueBadgeHex);
export default __webpack_public_path__ + "static/media/value-badge-hex.76d46700dcb9836b57c4769467eb9c3a.svg";
export { ForwardRef as ReactComponent };